(function () {
  try {
    if (window.UFCGetStartedExperiment) return;
    var WIZARD_PATH = '/pages/meal-plan-wizard';
    var CLASSIC_PATH = '/pages/meal-selection';
    var IS_EXISTING_CUSTOMER = document.getElementById('ufc-meal-flow').dataset.existingCustomer === 'true';
    var params = new URLSearchParams(window.location.search || '');
    var hash = window.location.hash || '';
    var search = window.location.search || '';
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';

    /* Retired A/B test cleanup — remove after a release cycle. */
    try {
      var sharedDomain = /(^|\.)ufcignite\.com$/i.test(window.location.hostname || '')
        ? '; Domain=.ufcignite.com'
        : '';
      document.cookie = 'ufc_gs_ab=; Max-Age=0; Path=/; SameSite=Lax; Secure' + sharedDomain;
      window.localStorage.removeItem('ufc_gs_ab');
    } catch (e) {}

    function normalizeShoppingPlan(value) {
      var plan = String(value || '').trim().toLowerCase().replace(/_/g, '-');
      if (plan === 'mix-match' || plan === 'mixmatch' || plan === 'mix-and-match' || plan === 'mixandmatch') plan = 'mix';
      return plan === 'cut' || plan === 'maintain' || plan === 'build' || plan === 'mix' ? plan : '';
    }
    function normalizeShoppingQty(value) {
      var qty = parseInt(String(value || '').trim(), 10);
      return qty === 4 || qty === 8 || qty === 12 || qty === 16 ? qty : 0;
    }
    var entry = String(params.get('entry') || '').trim().toLowerCase();
    var shoppingPlan = normalizeShoppingPlan(params.get('plan'));
    var shoppingQty = normalizeShoppingQty(params.get('qty'));
    var isShoppingPreselection = entry === 'shopping' && !!shoppingPlan && !!shoppingQty;
    function forceClassicDeepLink() {
      return (params.has('qty') && !isShoppingPreselection) || params.has('variant') || params.has('ufc_checkout');
    }
    var abParam = String(params.get('ab') || '').toLowerCase();
    var forcedByQa = abParam === 'wizard' || abParam === 'classic';

    var flow;
    var assignmentSource;
    if (forcedByQa) {
      flow = abParam;
      assignmentSource = 'qa_override';
    } else if (path.indexOf('meal-selection') !== -1) {
      /* Build a Box: landing on /pages/meal-selection always stays classic. */
      flow = 'classic';
      assignmentSource = 'build_a_box_page';
    } else if (forceClassicDeepLink()) {
      flow = 'classic';
      assignmentSource = 'legacy_deep_link';
    } else if (IS_EXISTING_CUSTOMER) {
      flow = 'classic';
      assignmentSource = 'existing_customer';
    } else {
      flow = 'wizard';
      assignmentSource = isShoppingPreselection ? 'shopping_preselected' : 'default';
    }

    if (path.indexOf('meal-plan-wizard') !== -1) {
      if (flow === 'classic') {
        window.location.replace(CLASSIC_PATH + search + hash);
        return;
      }
    } else if (path.indexOf('meal-selection') !== -1 && flow === 'wizard') {
      window.location.replace(WIZARD_PATH + search + hash);
      return;
    }

    window.__UFC_GS_AB_VARIANT = flow;
    document.documentElement.setAttribute('data-ufc-gs-ab', flow);
    var experimentContext = {
      experiment_id: 'get_started_flow_router_v2',
      experiment_variant: flow,
      customer_scope: IS_EXISTING_CUSTOMER ? 'existing' : 'new_or_guest',
      experiment_assignment_source: assignmentSource,
      assignment_reason: assignmentSource,
      entry: entry || 'direct',
      shopping_plan: isShoppingPreselection ? shoppingPlan : '',
      shopping_qty: isShoppingPreselection ? String(shoppingQty) : ''
    };
    function publishExperimentEvent(eventName, details, onComplete) {
      var parameters = Object.assign({}, experimentContext, details || {});
      if (assignmentSource === 'qa_override') parameters.debug_mode = true;
      if (window.UFCAnalytics) window.UFCAnalytics.publish(eventName, parameters);
      // A bounded navigation delay is not an acknowledgement from the pixel.
      if (typeof onComplete === 'function') window.setTimeout(onComplete, 300);
    }
    window.UFCGetStartedExperiment = {
      variant: flow,
      context: Object.assign({}, experimentContext),
      track: publishExperimentEvent,
      trackAndNavigate: function (eventName, details, destination) {
        var hasNavigated = false;
        publishExperimentEvent(eventName, details, function () {
          if (hasNavigated) return;
          hasNavigated = true;
          window.location.href = destination;
        });
      }
    };
  } catch (e) {}
})();

// GTM's old parent-DOM click listener could count rejected clicks. Publish only
// the accepted quantity change, after the meal selector has updated its state.
var pendingMealChange;
document.addEventListener('click', function (event) {
  var button = event.target.closest('.meal-add-btn, .meal-qty .plus, .meal-qty .minus, .mb-order-qty .plus, .mb-order-qty .minus');
  if (!button || button.disabled) return;
  var row = button.closest('.meal-row, .mb-order-item');
  var control = button.closest('.meal-qty, .mb-order-qty') || (row && row.querySelector('.meal-qty'));
  var productId = button.dataset.productId || (control && control.dataset.productId) || (row && row.dataset.productId);
  if (!productId) return;
  function quantity() {
    try { return Number(JSON.parse(window.localStorage.getItem('mb_counts') || '{}')[productId]) || 0; }
    catch (error) { return 0; }
  }
  var before = quantity();
  var item = {
    item_id: productId,
    item_variant: control && control.dataset.variantId || '',
    item_name: row && (row.querySelector('.meal-title, .mb-order-item__name') || {}).textContent || ''
  };
  var change = { productId: productId, before: before, item: item };
  pendingMealChange = change;
  window.setTimeout(function () {
    if (pendingMealChange === change) pendingMealChange = null;
  }, 0);
}, true);
window.addEventListener('mb:countsChanged', function (event) {
  var change = pendingMealChange;
  if (!change || !event.detail || !event.detail.counts) return;
  var delta = (Number(event.detail.counts[change.productId]) || 0) - change.before;
  if (!delta) return;
  pendingMealChange = null;
  if (!window.UFCAnalytics) return;
  change.item.quantity = Math.abs(delta);
  window.UFCAnalytics.publish(delta > 0 ? 'add_to_cart' : 'remove_from_cart', {
    source: 'meal_selection', ecommerce: { currency: 'USD', items: [change.item] }
  });
});


      (function () {
        var selector = [
          '.klaviyo-form',
          '[id^="klaviyo-form-"]',
          '.needsclick[class*="kl-private-reset-css"]',
          '[data-testid*="klaviyo-form"]'
        ].join(',');
        var scheduled = false;

        function suppressKlaviyoSignupForms() {
          scheduled = false;
          if (!document.querySelectorAll) return;

          var nodes = document.querySelectorAll(selector);
          var removed = false;
          Array.prototype.forEach.call(nodes, function (node) {
            if (!node || !node.isConnected) return;

            var container = node.closest && node.closest('[role="dialog"]');
            if (!container && node.closest) {
              container = node.closest('.needsclick[class*="kl-private-reset-css"]');
            }
            container = container || node;

            if (container && container.parentNode) {
              container.parentNode.removeChild(container);
              removed = true;
            }
          });

          var ufcModalOpen = document.body && document.body.matches([
            '.mpw-email-modal-open',
            '.mb-mobile-box-lock',
            '.mb-mobile-consent-lock',
            '.mb-meal-modal-lock',
            '.mb-plan-switch-lock'
          ].join(','));
          if (removed && document.body && !ufcModalOpen) {
            document.documentElement.style.removeProperty('overflow');
            document.body.style.removeProperty('overflow');
          }
        }

        function scheduleSuppression() {
          if (scheduled) return;
          scheduled = true;
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(suppressKlaviyoSignupForms);
          } else {
            window.setTimeout(suppressKlaviyoSignupForms, 0);
          }
        }

        function startGuard() {
          suppressKlaviyoSignupForms();
          if (!window.MutationObserver || !document.documentElement) return;
          new MutationObserver(scheduleSuppression).observe(document.documentElement, {
            childList: true,
            subtree: true
          });
        }

        window.addEventListener('klaviyoForms', scheduleSuppression);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', startGuard, { once: true });
        } else {
          startGuard();
        }
      })();
